import React, { useRef, useEffect } from 'react';

interface JsonEditorProps {
  value: string;
  onChange: (value: string) => void;
}

const JsonEditor: React.FC<JsonEditorProps> = ({ value, onChange }) => {
  const preRef = useRef<HTMLPreElement>(null);

  const syntaxHighlight = (json: string) => {
    if (!json) return '';
    json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, (match) => {
        let cls = 'json-number';
        if (/^"/.test(match)) {
            if (/:$/.test(match)) {
                cls = 'json-key';
            } else {
                cls = 'json-string';
            }
        } else if (/true|false/.test(match)) {
            cls = 'json-boolean';
        } else if (/null/.test(match)) {
            cls = 'json-null';
        } else if (/[{}[\]]/.test(match)) {
            cls = 'json-brace';
        } else if (/,/.test(match)) {
             cls = 'json-comma';
        }
        return `<span class="${cls}">${match}</span>`;
    });
  };

  useEffect(() => {
    if (preRef.current) {
        preRef.current.innerHTML = syntaxHighlight(value);
    }
  }, [value]);
  
  const handleInput = (e: React.FormEvent<HTMLTextAreaElement>) => {
    onChange(e.currentTarget.value);
  };
  
  return (
    <div className="relative font-mono text-sm leading-relaxed h-[70vh]">
        <textarea
            value={value}
            onChange={handleInput}
            spellCheck="false"
            className="absolute inset-0 w-full h-full p-4 bg-transparent text-transparent caret-white resize-none border-0 outline-none"
            style={{ tabSize: 2, WebkitTextFillColor: 'transparent' }}
        />
        <pre ref={preRef} aria-hidden="true" className="absolute inset-0 w-full h-full p-4 bg-transparent text-white pointer-events-none overflow-auto whitespace-pre-wrap break-words" style={{ tabSize: 2 }}>
            {/* The highlighted content will be rendered here */}
        </pre>
    </div>
  );
};

export default JsonEditor;
